export const isXsScreen = () => {
  return window !== undefined && window.innerWidth < 400;
};

export const isSmScreen = () => {
  return window !== undefined && window.innerWidth < 520;
};
